import { render } from "./Footer_en.vue?vue&type=template&id=32b72437"
import script from "./Footer_en.vue?vue&type=script&lang=js"
export * from "./Footer_en.vue?vue&type=script&lang=js"

import "./Footer_en.vue?vue&type=style&index=0&id=32b72437&lang=css"
script.render = render

export default script